import React from 'react';
import { Typography } from '@material-ui/core';
import { TextFormattedNumber } from 'components';
import { useStyles } from '../styles';


interface IQuotedSummaryItem {
  label: string,
  hint?: string,
  value: number,
  prefix?: string
}

const QuotedSummaryItem = ({ label, hint, value, prefix = '$' }: IQuotedSummaryItem) => {
  const classes = useStyles();

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between">
        <Typography variant="h5"  className={classes.customQuoteSummaryTypography}>
          {label}
        </Typography>
        <Typography variant="h5" align="right" className={classes.customQuoteSummaryTypography}>
          <TextFormattedNumber value={value} prefix={prefix} />
        </Typography>
      </div>
      {hint && <Typography className="text-14 text-light-gray font-medium mr-2">{hint}</Typography>}
    </div>
  );
};

export default QuotedSummaryItem;
